// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3p3_f","right":"styles_right__2fidZ"};